import { DELETE_CUSTOM_CLAIM_FAILURE } from 'actions'
import { DeleteCustomClaimFailureAction } from './types/DeleteCustomClaimFailureAction'

export const createDeleteCustomClaimFailureAction = (): DeleteCustomClaimFailureAction => {
  return {
    type: DELETE_CUSTOM_CLAIM_FAILURE,
  }
}
